import { render, staticRenderFns } from "./workForm.vue?vue&type=template&id=5a459331&scoped=true&"
import script from "./workForm.vue?vue&type=script&lang=js&"
export * from "./workForm.vue?vue&type=script&lang=js&"
import style0 from "./workForm.vue?vue&type=style&index=0&id=5a459331&prod&lang=less&scoped=true&"
import style1 from "./workForm.vue?vue&type=style&index=1&id=5a459331&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a459331",
  null
  
)

export default component.exports